import { render, staticRenderFns } from "./Artists.vue?vue&type=template&id=98c4b25c"
import script from "./Artists.vue?vue&type=script&lang=js"
export * from "./Artists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports